import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { 
  Video,
  ArrowLeft
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import BreadcrumbSchema from '../components/BreadcrumbSchema';
import YouTubeDownloader from '../components/tools/YouTubeDownloader';

const Tools: React.FC = () => {
  const { currentUser } = useAuth();

  return (
    <>
      <Helmet>
        <title>Free YouTube Downloader - ClipThis</title>
        <meta name="description" content="Free YouTube downloader. Download YouTube videos as MP4 or extract audio as MP3. Fast, secure, and no registration required." />
        <meta name="keywords" content="YouTube downloader, free YouTube downloader, YouTube to MP3, YouTube to MP4, download YouTube videos" />
      </Helmet>
      <BreadcrumbSchema items={[
        { name: 'YouTube Downloader', path: '/downloads' }
      ]} />

      <div className="min-h-screen relative overflow-x-hidden" style={{ minHeight: 'calc(100vh - 64px)' }}>
        {/* Subtle animated background */}
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        
        <div className="relative z-10 px-6 sm:px-8 pt-4 animate-fade-up">
          {/* Back Button */}
          <Link 
            to={currentUser ? "/dashboard" : "/"}
            className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            <span>Back to {currentUser ? "Dashboard" : "Home"}</span>
          </Link>
        
        {/* Hero Section */}
        <div className="py-4">
          <div className="max-w-7xl mx-auto">
            <div className="text-center">
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 bg-red-600 rounded-xl flex items-center justify-center">
                  <Video className="w-8 h-8 text-white" />
                </div>
              </div>
              <h1 className="text-5xl font-display font-bold tracking-tight mb-4">
                YouTube Downloader
              </h1>
              <p className="text-xl text-primary-600 max-w-3xl mx-auto">
                Free YouTube video and audio downloader. Download MP4 videos or extract MP3 audio files instantly.
              </p>
            </div>
          </div>
        </div>

        {/* YouTube Downloader Content */}
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-8">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl border border-primary-100 shadow-sm">
            <YouTubeDownloader />
          </div>
        </div>
        </div>

      </div>
    </>
  );
};

export default Tools;
